import { toast } from "react-toastify";
import {
  startLoading,
  stopLoading,
  hasError,
  handleCountryStateDetails,
  handleCountryGridDetails,
} from "../redux/slices/countryApiSlice.ts";
import { method, paths } from "./ServiceConstants.tsx";
import ServicesManagerAPICall from "./ServicesManagerAPICall.tsx";
import { handleAuthentication } from "../redux/slices/loginApiSlice.ts";

export const checkTokenMessage = (res: any) => {
  const message = res?.message ? res?.message.toLowerCase() : "";
  if (
    message.includes("invalid") ||
    message.includes("token has expired") ||
    message === "token is missing!"
  ) {
    return true;
  }
  return false;
};
export const fetchCountryStateWiseDetails = (data) => {
  return async (dispatch: any) => {
    dispatch(startLoading());
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.STATE_VIEW_DATA_V2,
        data,
        true,
        false,
      ).then(
        (tableData: any) => {
          if (tableData != null) {
            if (checkTokenMessage(tableData)) {
              dispatch(handleAuthentication({}));
            } else {
              dispatch(handleCountryStateDetails(tableData));
            }
          } else {
            toast("Unable to fetch data, please try again later");
          }
        },
        (err: any) => {
          dispatch(stopLoading());
          toast("Unable to fetch data, please try again later");
        }
      );
    } catch (error) {
      dispatch(stopLoading());
      toast("Unable to fetch data, please try again later");
      dispatch(hasError(error.toString()));
    }
  };
};
export const fetchCountryGridWiseDetails = (params) => {  
  return async (dispatch: any) => {
    dispatch(startLoading());
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.STATE_VIEW_DATA_V2,
        params,
        true,
        false
      ).then(
        (tableData: any) => {
          if (tableData != null) {
            if (checkTokenMessage(tableData)) {
              dispatch(handleAuthentication({}));
            } else {
              dispatch(handleCountryGridDetails(tableData));
            }
          } else {
            toast("Unable to fetch data, please try again later");
          }
        },
        (err: any) => {
          dispatch(stopLoading());
          toast("Unable to fetch data, please try again later");
        }
      );
    } catch (error) {
      dispatch(stopLoading());
      toast("Unable to fetch data, please try again later");
      dispatch(hasError(error.toString()));
    }
  };
};